import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";

import { GetUserRequest, type GetUserResponse, type IReturn } from "src/api/Tmd.dtos";

import useApi from "../api/useApi";

const getData = (response?: SWRResponse<GetUserResponse, GetUserResponse>) =>
    response?.data?.userDetails;
const getError = (response?: SWRResponse<GetUserResponse, GetUserResponse>) =>
    (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetUserResponse, GetUserResponse>) => ({});

/**
 * Loads authenticated-user details through a memoized GetUser GET request.
 *
 * Postconditions: Returns shared API state projected to user details and response status. Request
 * construction is memoized for the hook lifetime; no login or logout action is performed here.
 */
const useAuthenticatedUser = (
    configuration?: SWRConfiguration<GetUserResponse, GetUserResponse>
) => {
    const getRequest = useMemo(
        () => {
            return (): IReturn<GetUserResponse> => {
                return new GetUserRequest();
            };
        },
        []
    );

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useAuthenticatedUser;
